module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "stats"
    }
  }, [_c('header', [_c('a', {
    staticClass: "back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goBack($event)
      }
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Statistik")])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "item"
  }, [_c('dp', {
    attrs: {
      "who": _vm.data.user
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm._f("name")(_vm.data.user)))])], 1)]), _vm._v(" "), _c('section', [_c('header', [_c('h2', [_vm._v("\n                ELO: " + _vm._s(_vm.data.user.elo) + " \n                "), (_vm.eloChange > 0) ? [_vm._v("\n                    (" + _vm._s(_vm.eloChange) + " ⬆️)\n                ")] : _vm._e(), _vm._v(" "), (_vm.eloChange < 0) ? [_vm._v("\n                    (" + _vm._s(_vm.eloChange) + " ⬇️)\n                ")] : _vm._e(), _vm._v(" "), (_vm.eloChange == 0) ? [_vm._v("\n                    (±0)\n                ")] : _vm._e()], 2), _vm._v(" "), _c('toggle', {
    attrs: {
      "choices": {
        'day': 'T',
        'week': 'W',
        'month': 'M',
        'year': 'Y'
      }
    },
    model: {
      value: (_vm.eloTimeframe),
      callback: function($$v) {
        _vm.eloTimeframe = $$v
      },
      expression: "eloTimeframe"
    }
  })], 1), _vm._v(" "), _c('elo-chart', {
    attrs: {
      "matches": _vm.matchesInTimeframe,
      "userId": _vm.userId,
      "startTime": +_vm.startTime,
      "endTime": +new Date
    }
  })], 1), _vm._v(" "), _c('section', [_c('header', [_c('h2', [_vm._v("Spiele")]), _vm._v(" "), _c('toggle', {
    attrs: {
      "choices": {
        'all': 'Alle',
        'free': 'Freie',
        'tournaments': 'Turniere'
      }
    },
    model: {
      value: (_vm.statFilter),
      callback: function($$v) {
        _vm.statFilter = $$v
      },
      expression: "statFilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "stats"
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.stats.matches[_vm.statFilter].wins) + " / " + _vm._s(_vm.stats.matches[_vm.statFilter].total || 0))]), _vm._v(" "), _c('div', {
    staticClass: "pie-chart"
  }, [_c('pie-chart', {
    attrs: {
      "wins": _vm.stats.matches[_vm.statFilter].wins,
      "losses": _vm.stats.matches[_vm.statFilter].losses
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v("Spiele gewonnen")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(_vm.stats.games[_vm.statFilter].wins) + " / " + _vm._s(_vm.stats.games[_vm.statFilter].total || 0))]), _vm._v(" "), _c('div', {
    staticClass: "pie-chart"
  }, [_c('pie-chart', {
    attrs: {
      "wins": _vm.stats.games[_vm.statFilter].wins,
      "losses": _vm.stats.games[_vm.statFilter].losses
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v("Sätze gewonnen")])])])]), _vm._v(" "), _c('section', [_c('h2', [_vm._v("Punkte")]), _vm._v(" "), _c('div', {
    staticClass: "stats"
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.stats.points[_vm.statFilter].points))]), _vm._v(" "), _c('label', [_vm._v("Insgesamt")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s((_vm.stats.points[_vm.statFilter].points / _vm.stats.matches[_vm.statFilter].total || 0).toLocaleString("de", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
  })))]), _vm._v(" "), _c('label', [_vm._v("pro Spiel")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s((_vm.stats.points[_vm.statFilter].points / _vm.stats.games[_vm.statFilter].total || 0).toLocaleString("de", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
  })))]), _vm._v(" "), _c('label', [_vm._v("pro Satz")])])])]), _vm._v(" "), _c('section', [_c('h2', [_vm._v("Ranglisten")]), _vm._v(" "), _c('div', {
    staticClass: "stats"
  }, [_c('router-link', {
    attrs: {
      "to": ("/users/" + _vm.userId + "/ranking/global")
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.data.ranks.global))]), _vm._v(" "), _c('label', [_vm._v("Weltweit")])]), _vm._v(" "), (_vm.data.user.city) ? _c('router-link', {
    attrs: {
      "to": ("/users/" + _vm.userId + "/ranking/city")
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.data.ranks.city))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.data.user.city.name))])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": ("/users/" + _vm.userId + "/ranking/friends")
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.data.ranks.friends))]), _vm._v(" "), _c('label', [_vm._v("Freunde")])]), _vm._v(" "), (_vm.data.user.year) ? _c('router-link', {
    attrs: {
      "to": ("/users/" + _vm.userId + "/ranking/year")
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.data.ranks.year))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm._f("grade")(_vm.data.user.year)) + ". Klasse")])]) : _vm._e(), _vm._v(" "), (_vm.data.user.school) ? _c('router-link', {
    attrs: {
      "to": ("/users/" + _vm.userId + "/ranking/school")
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.data.ranks.school))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.data.user.school.name))])]) : _vm._e()], 1)]), _vm._v(" "), (_vm.data.awards.length > 0) ? _c('section', [_c('h2', [_vm._v("Trophäen")]), _vm._v(" "), _vm._l((_vm.data.awards), function(award) {
    return _c('div', {
      staticClass: "item"
    }, [_c('div', {
      class: ("award-img award-" + (award.type))
    }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(award.tournament.name))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm._f("award_type")(award.type)))])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.matches.length > 0) ? _c('section', [_c('header', [_c('h2', [_vm._v("Abgeschlossene Spiele")]), _vm._v(" "), _c('toggle', {
    attrs: {
      "choices": {
        'all': 'Alle',
        'free': 'Freie',
        'tournaments': 'Turniere'
      }
    },
    model: {
      value: (_vm.matchFilter),
      callback: function($$v) {
        _vm.matchFilter = $$v
      },
      expression: "matchFilter"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.matches), function(req) {
    return (req.status == 'completed' && _vm.matchFilter != 'tournaments' && (_vm.matchFilter == 'all' || req.tournament_id === null)) ? _c('router-link', {
      key: req.id,
      staticClass: "item",
      attrs: {
        "to": '/match/' + req.id
      }
    }, [_c('dp', {
      attrs: {
        "who": req.player_a_id == _vm.userId ? req.player_b : req.player_a
      }
    }), _vm._v(" "), (req.player_a_id == _vm.userId) ? _c('h3', [_vm._v("\n                " + _vm._s(req.player_b.firstname + ' ' + req.player_b.lastname) + "\n            ")]) : _c('h3', [_vm._v("\n                " + _vm._s(req.player_a.firstname + ' ' + req.player_a.lastname) + "\n            ")]), _vm._v(" "), (req.player_a_id == _vm.userId) ? _c('p', [_vm._v("\n                " + _vm._s(req.points_a) + ":" + _vm._s(req.points_b) + " -\n                ELO " + _vm._s(_vm._f("plusminus")(req.elo_a_delta)) + "\n            ")]) : _c('p', [_vm._v("\n                " + _vm._s(req.points_b) + ":" + _vm._s(req.points_a) + " -\n                ELO " + _vm._s(_vm._f("plusminus")(req.elo_b_delta)) + "\n            ")]), _vm._v(" "), (req.tournament) ? _c('small', [_vm._v("\n                Teil eines Turniers\n                "), (req.type != 'regular') ? [_vm._v("\n                    (Ausscheidungsphase)\n                ")] : _vm._e()], 2) : _vm._e()], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.tournaments), function(t) {
    return (_vm.matchFilter == 'tournaments') ? _c('div', {
      key: t.tournament.id,
      staticClass: "item tournament"
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.expandTournament(t)
        }
      }
    }, [_c('img', {
      staticClass: "tournament",
      attrs: {
        "src": "images/tournament-dark.png"
      }
    }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(t.tournament.name))]), _vm._v(" "), _c('p', [_vm._v("ELO " + _vm._s(_vm._f("plusminus")(t.eloDelta)))])]), _vm._v(" "), (_vm.expandedTournament == t.tournament.id) ? _c('div', _vm._l((t.matches), function(req) {
      return (req.status == 'completed') ? _c('router-link', {
        key: req.id,
        staticClass: "item",
        attrs: {
          "to": '/match/' + req.id
        }
      }, [_c('dp', {
        attrs: {
          "who": req.player_a_id == _vm.userId ? req.player_b : req.player_a
        }
      }), _vm._v(" "), (req.player_a_id == _vm.userId) ? _c('h3', [_vm._v("\n                        " + _vm._s(req.player_b.firstname + ' ' + req.player_b.lastname) + "\n                    ")]) : _c('h3', [_vm._v("\n                        " + _vm._s(req.player_a.firstname + ' ' + req.player_a.lastname) + "\n                    ")]), _vm._v(" "), (req.player_a_id == _vm.userId) ? _c('p', [_vm._v("\n                        " + _vm._s(req.points_a) + ":" + _vm._s(req.points_b) + " -\n                        ELO " + _vm._s(_vm._f("plusminus")(req.elo_a_delta)) + "\n                    ")]) : _c('p', [_vm._v("\n                        " + _vm._s(req.points_b) + ":" + _vm._s(req.points_a) + " -\n                        ELO " + _vm._s(_vm._f("plusminus")(req.elo_b_delta)) + "\n                    ")]), _vm._v(" "), _c('small', [_vm._v("\n                        Teil eines Turniers\n                        "), (req.type != 'regular') ? [_vm._v("\n                            (Ausscheidungsphase)\n                        ")] : _vm._e()], 2)], 1) : _vm._e()
    })) : _vm._e()]) : _vm._e()
  })], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2eefb4d1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/stats.vue
// module id = 223
// module chunks = 0